import React from "react";
import MainDrawingWrapper from "../../components/lotto6/MainDrawingWrapper";
import Dashboard2Mix from "../../components/lotto6/mix/Dashboard2Mix";
import BettingDialog from "../../components/lotto5/BettingDialog";
import {useLotto6} from "../../store/lotto6/Lotto6Context";

const Lotto6DashboardMix = ({appClass = ""}) => {
    return <MainDrawingWrapper appClass={appClass} stSize={{row: 6, column: 7}} isIframe={true}>
        <Lotto6MixWrapper appClass={appClass}/>
    </MainDrawingWrapper>
}

const Lotto6MixWrapper = ({appClass}) => {
    const lotto = useLotto6();
    const platform = lotto.platform;
    return <div className="lotto6-mix m-lotto-1">
        <Dashboard2Mix platform={platform} {...lotto} appClass={appClass}/>
        <BettingDialog
            changeBetAmount={lotto.changeBetAmount}
            clickAmountBetBtn={lotto.clickAmountBetBtn}
            onConfirmBettingLotto5={lotto.onConfirmBetting}
            resetDefaultAmount={lotto.resetDefaultAmount}
            onCancelBetting={lotto.onCancelBetting}
            classDialog="bet-mix-dialog"
            appClass={appClass}
            {...lotto}
        />
    </div>
}

export default Lotto6DashboardMix;
